import { customFieldAttribute } from '@libs/enums';
import type { CustomFieldSetting } from '../hooks';
import type { SingleCustomField } from '../models';

function createCustomFieldId(customFieldSetting: CustomFieldSetting, index?: number) {
  const customMstCode = 'custom-mst-code';
  const customFieldValue = 'custom-field-value';
  const indexStr = index !== undefined && !Number.isNaN(index) ? `-${index}-` : '';
  const key = `${indexStr}${String(customFieldSetting.customFieldKey).padStart(2, '0')}`;
  if (customFieldSetting.basicSetting.attribute === customFieldAttribute.enum.mstCode) {
    return customMstCode + key;
  } else {
    return customFieldValue + key;
  }
}

function createCustomFields(customFields: SingleCustomField[]) {
  return Object.fromEntries(
    customFields.map((curr) => [curr.customFieldKey.toString(), curr.customFieldValue]),
  );
}

export { createCustomFields, createCustomFieldId };
